import { useEffect, useState } from 'react';

function useDebounce(value: string | number, timeout: number, callback: () => void) {
  const [timer, setTimer] = useState<ReturnType<typeof setTimeout> | null>(null);

  const clearTimer = () => {
    if (timer) clearTimeout(timer);
  };

  useEffect(() => {
    clearTimer();

    if (value && callback) {
      const newTimer = setTimeout(callback, timeout);
      setTimer(newTimer);
    }
  }, [value]);
}
export default useDebounce;
